import { Link } from 'react-router-dom';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Tab from '@zenbusiness/zui/Tab';
import Tabs from '@zenbusiness/zui/Tabs';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import useCurrentTab from '../../hooks/useCurrentTab';

export const LOCALIZED_TEXT = {
  gettingStarted: 'dashboard.learningHub.tabs.title1',
  runningAndGrowing: 'dashboard.learningHub.tabs.title2',
  educationTabsAriaLabel: 'dashboard.learningHub.ariaLabel.educationTabs'
};

function EducationTabs() {
  const { formatMessage: fm } = useIntl();
  const educationPath = useDashboardPath('/education');

  const routes = {
    gettingStarted: educationPath,
    runningAndGrowing: `${educationPath}/running-and-growing`
  };

  const educationRoutes = Object.values(routes);
  const currentTab = useCurrentTab(educationRoutes, routes.gettingStarted);

  const tabData = [
    {
      label: fm({ id: LOCALIZED_TEXT.gettingStarted }),
      to: routes.gettingStarted,
      value: routes.gettingStarted
    },
    {
      label: fm({ id: LOCALIZED_TEXT.runningAndGrowing }),
      to: routes.runningAndGrowing,
      value: routes.runningAndGrowing
    }
  ];

  return (
    <Tabs aria-label={fm({ id: LOCALIZED_TEXT.educationTabsAriaLabel })} divider value={currentTab}>
      {tabData.map(({ label, to, value }) => (
        <Tab
          key={label}
          component={Link}
          label={label}
          to={to}
          value={value}
        />
      ))}
    </Tabs>
  );
}

export default EducationTabs;
